import { FieldSwitch, HelpIcon, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { Field } from 'redux-form';

import { Props, useOnToggleClick } from './toggleBoxHead';
import styles from './toggleBoxHead.module.scss';

export function FieldToggleBoxHead({
  isOpen = false,
  title,
  className,
  textProps,
  helpIcon,
  onChange,
  input,
  disabled,
}: Props): JSX.Element {
  const onToggleClick = useOnToggleClick(onChange, isOpen);
  const rootClass = classnames(className, styles.root);

  return (
    <div className={rootClass}>
      <span className={styles.header}>
        <label htmlFor={input.id}>
          <Text.Paragraph variant="1" {...textProps} as="span">
            {title}
          </Text.Paragraph>
        </label>
        {helpIcon && <HelpIcon {...helpIcon} />}
      </span>
      <Field
        component={FieldSwitch}
        type="checkbox"
        id={input.id}
        name={input.name}
        checked={isOpen}
        onChange={onToggleClick}
        disabled={disabled}
      />
    </div>
  );
}
